import Queue from "./queue";

export default Queue;
